@import "../../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template-rows: max-content 1fr max-content;
}

.section {
  display: contents;
}

// - - - - - - - - - - -
// Header
// - - - - - - - - - - -

header {
  display: grid;
  grid-template-rows: max-content;
  grid-template-columns: 1fr 1fr max-content;
}

.button-change {
  align-self: center;
  justify-self: end;
}

// - - - - - - - - - - -
// Main
// - - - - - - - - - - -

.main {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content 1fr max-content max-content;
}

.search-kbs {
  inline-size: 50%;
}

.versions-container {
  grid-auto-rows: max-content;

  &__input {
    display: grid;
    grid-template-columns: 1fr max-content;
    gap: var(--spacing-gap-m);
  }
}
